module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJdJREFUeNpibGho8GNgYPhYX19/kAENNDY22gMpfiYg8QWI10EF0BWsA8kz/v//HyTgBOSsBuIgkIlICkKB/H1gRVCdMIUdQFwBUwCSgyuCKiwFUl1AXAZU0A0TZ0JzA8iEMhANNRmhCCoAcwPIhFCQ1TCFzIyMjDC3wN3g4OBw/+DBg2dA4iAaZBIPsgIYgPJBJvIABBgArx1JPyk4sToAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub-nav-del.png
// module id = fhKr
// module chunks = 85